import { useState } from 'react';
import { ESASAssessment } from '@/components/ESASAssessment';
import { EmptyTemplate } from '@/components/EmptyTemplate';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileText, Calculator } from 'lucide-react';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-blue-800 mb-2">ESAS Palliativ-Assessment Tool</h1>
          <p className="text-lg text-gray-600">Digitales Edmonton Symptom Assessment System für die Palliativpflege</p>
        </div>
        
        <Tabs defaultValue="assessment" className="w-full">
          <TabsList className="grid w-full grid-cols-2 max-w-md mx-auto mb-8">
            <TabsTrigger value="assessment" className="flex items-center gap-2">
              <Calculator className="w-4 h-4" />
              Digitales Assessment
            </TabsTrigger>
            <TabsTrigger value="template" className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              Leere Vorlage
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="assessment">
            <ESASAssessment />
          </TabsContent>
          
          <TabsContent value="template">
            <EmptyTemplate />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Index;
